import {createSlice} from "@reduxjs/toolkit";

const initialActiveVasOffersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  activeVasOffersList: null,
  activeVasOfferForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const blueProgramSlice = createSlice({
  name: "blueProgram",
  initialState: initialActiveVasOffersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    buyPointsSlice: (state, action) => {
      // const { activeVasOffersList } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      // state.activeVasOffersList = activeVasOffersList;
    },
  }
});
